// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Check from "@awc/XDL/Icons/Check";
import Plus from "@awc/XDL/Icons/Plus";
import { createLinkIconStyles } from "@awc/XDL/Utilities";
import { ShareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";
import Printer from "@insite/mobius/Icons/Printer";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { css } from "styled-components";

interface MyAccountDetailsStyles {
    myAccountDetailsActions?: {
        saveOrderLink?: LinkPresentationProps;
        placeOrderLink?: LinkPresentationProps;
        acceptLink?: LinkPresentationProps;
        addAllToListClickable?: LinkPresentationProps;
        removeAllLink?: LinkPresentationProps;
        printLink?: LinkPresentationProps;
        emailLink?: ShareEntityButtonStyles;
    };
}

const myAccountDetailsStyles: MyAccountDetailsStyles = {
    myAccountDetailsActions: {
        saveOrderLink: {
            ...createLinkIconStyles({ icon: Save, sizeVariant: "large" }),
        },
        placeOrderLink: {
            ...createLinkIconStyles({ icon: Save, sizeVariant: "large" }),
        },
        acceptLink: {
            ...createLinkIconStyles({ icon: Check, sizeVariant: "large" }),
        },
        addAllToListClickable: {
            ...createLinkIconStyles({ icon: Plus, sizeVariant: "large" }),
        },
        removeAllLink: {
            ...createLinkIconStyles({ icon: Trash2, sizeVariant: "large" }),
        },
        printLink: {
            ...createLinkIconStyles({
                icon: Printer,
                sizeVariant: "large",
                linkStyles: {
                    icon: {
                        iconProps: {
                            size: 16,
                            css: css`
                                &,
                                & > svg {
                                    height: 16px;
                                }
                            `,
                        },
                    },
                },
            }),
        },
        emailLink: {
            button: {
                variant: "primary",
            },
        },
    },
};

export default myAccountDetailsStyles;
